// extracted by mini-css-extract-plugin
export default {"completedInfo":"MbtiElicit_completedInfo__sXunf","MBTIAnswers":"MbtiElicit_MBTIAnswers__m4Ip-"};